@if (!!maxProducts && !!classifications && !!products) {
  <sd-product-comparator
    [isSSR]="isSSR"
    [maxProducts]="!isReadOnlyAccordion ? maxProducts : null"
    [classifications]="classifications"
    [entries]="products"
    [promotedProduct]="productsHasBestSeller"
    [compareOnLoad]="compareOnLoad"
    (addNewProduct)="addProduct()"
    (deleteProduct)="removeProduct($event)"
    (deleteLastProduct)="removeLastProduct()"
    (addProductToCart)="addToCart($event)"
    [readonly]="isReadOnly"
    [isReadOnlyAccordion]="isReadOnlyAccordion"
    [brand]="brandCorner"
    (notifyProduct)="notifyMeProduct($event)"
    (productClicked)="onProductClick($event)"
    (productSellerModal)="openSellerModal()"
    (openRecommendedPriceModal)="openRecommendedPriceModal()"
  />
}

<sd-product-seller-modal [(isOpened)]="isOpenedSellerModal" />

<wc-product-notification-modal
  [productCode]="notifyProduct"
  [productName]="notifyProductName"
  [(notifyModalOpened)]="notifyModalOpened"
/>

<wc-omnibus-recommended-price-modal [(isOpenedRecommendedPriceModal)]="isOpenedRecommendedModal" />
